// ═══════════════════════════════════════
// ACTION-MENU — Menus déroulants de la barre d'actions
// (Télécharger, Voix). Ouverture vers le haut ; fermeture au clic
// extérieur, sur Échap, ou après le choix d'une entrée
// (sauf entrée marquée data-keep-open).
// ═══════════════════════════════════════

let _openWrap = null;

function _close(wrap) {
    if (!wrap) return;
    wrap.querySelector('.ctrl-menu-toggle')?.setAttribute('aria-expanded', 'false');
    const menu = wrap.querySelector('.ctrl-menu');
    if (menu) menu.hidden = true;
    if (_openWrap === wrap) _openWrap = null;
}

function _open(wrap) {
    if (_openWrap && _openWrap !== wrap) _close(_openWrap);
    // Permet au contenu du menu de se rafraîchir juste avant l'affichage
    wrap.dispatchEvent(new CustomEvent('ctrl-menu:open'));
    wrap.querySelector('.ctrl-menu-toggle')?.setAttribute('aria-expanded', 'true');
    const menu = wrap.querySelector('.ctrl-menu');
    if (menu) menu.hidden = false;
    _openWrap = wrap;
}

export function closeActionMenus() {
    _close(_openWrap);
}

export function initActionMenus() {
    document.querySelectorAll('.ctrl-menu-wrap').forEach(wrap => {
        const toggle = wrap.querySelector('.ctrl-menu-toggle');
        const menu   = wrap.querySelector('.ctrl-menu');
        if (!toggle || !menu) return;

        toggle.addEventListener('click', () => {
            if (toggle.getAttribute('aria-expanded') === 'true') _close(wrap);
            else _open(wrap);
        });

        // Une entrée choisie referme le menu, sauf data-keep-open
        menu.addEventListener('click', (e) => {
            const item = e.target.closest('.ctrl-menu-item');
            if (item && !item.hasAttribute('data-keep-open')) _close(wrap);
        });
    });

    // Clic extérieur. composedPath() est figé au moment du clic :
    // il reste valable si le contenu du menu vient d'être reconstruit.
    document.addEventListener('click', (e) => {
        if (_openWrap && !e.composedPath().includes(_openWrap)) _close(_openWrap);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !_openWrap) return;
        const toggle = _openWrap.querySelector('.ctrl-menu-toggle');
        _close(_openWrap);
        toggle?.focus();
    });
}
